<script>
  import IntroText from './IntroText.svelte';
  import RihannaIntro from '$lib/ai2svelte/rihanna-text-intro.svelte';
  import HeadlineEnder from './HeadlineEnder.svelte';
  import { Block } from '@reuters-graphics/graphics-components';
  import { assets } from '$app/paths';

  export let introElements;
</script>

<Block class="fluid headline-intro-container">
  <div class="text-cut-intro-container">
    <div class="text-wrapper">
      <IntroText {introElements} />
    </div>
    <div
      class="cutout-wrapper"
      aria-label="A collage-style timeline of Rihanna's gowns on the Met Gala red carpet from 2007-2023, showing how they began growing in size and complexity starting in 2015; her white, billowing gown becomes a charcoal outline and a red carpet appears behind her."
    >
      <RihannaIntro assetsPath={assets || '/'} />
    </div>
  </div>
  <div class="headline-ender-wrapper">
    <HeadlineEnder />
  </div>
</Block>

<style lang="scss">
  :global(.headline-intro-container) {
    height: 100%;
    position: relative;
  }
  .text-cut-intro-container {
    position: relative;
    height: 2880px;
    width: 100%;
    max-width: 1200px;
    margin: auto;
    .cutout-wrapper,
    .text-wrapper {
      position: absolute;
      width: 100%;
      height: 100%;
    }
  }
  .headline-ender-wrapper {
    position: absolute;
    width: 100%;
    bottom: 0;
  }

  @media (max-width: 1214px) {
    .text-cut-intro-container {
      max-width: 930px;
    }
  }

  @media (max-width: 944px) {
    .text-cut-intro-container {
      max-width: 660px;
    }
  }

  @media (max-width: 674px) {
    .text-cut-intro-container {
      max-width: 510px;
      height: 3018px;
    }
  }

  @media (max-width: 524px) {
    .text-cut-intro-container {
      max-width: 330px;
      height: 1970px;
    }
  }
</style>
